export function Brand({ compact = false, inverted = false }: { compact?: boolean; inverted?: boolean }) {
  return (
    <div className={`brand ${compact ? 'brand--compact' : ''} ${inverted ? 'brand--inverted' : ''}`}>
      <img className="brand__mark" src="/brand/finojan-mark.svg" alt="" />
      {!compact && (
        <span className="brand__word">
          <b>فینوژان</b>
          <small>هوش تحلیل مالی</small>
        </span>
      )}
    </div>
  );
}
